import { useEffect, useState } from 'react';
//import { useTranslation } from 'react-i18next';
import { Location, useLocation, useNavigate } from 'react-router-dom';
import { IMenuItem } from '../../store/reducers/menu';

const MenuItem = ({ menuItem }: { menuItem: IMenuItem }) => {
    //const [t] = useTranslation();
    const [isMenuExtended, setIsMenuExtended] = useState(false);
    const [isExpandable, setIsExpandable] = useState(false);
    const [isMainActive, setIsMainActive] = useState(false);
    const [isOneOfChildrenActive, setIsOneOfChildrenActive] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuExtended(!isMenuExtended);
    };

    const handleMainMenuAction = () => {
        if (isExpandable) {
            toggleMenu();
        }
        if (menuItem.url && menuItem.url !== '#') {
            navigate(menuItem.url);
        } else if (!isExpandable) {
            navigate('/');
        }
    };

    const checkIsActive = (item: IMenuItem, pathname: string): boolean => {
        if (item.url === pathname) return true;
        if (item.children) {
            return item.children.some(child => checkIsActive(child, pathname));
        }
        return false;
    };

    const calculateIsActive = (url: Location) => {
        setIsMainActive(false);
        setIsOneOfChildrenActive(false);
        
        if (menuItem.url === url.pathname) {
            setIsMainActive(true);
        }

        if (isExpandable && menuItem && menuItem.children) {
            const hasActiveChild = menuItem.children.some(child => checkIsActive(child, url.pathname));
            if (hasActiveChild) {
                setIsOneOfChildrenActive(true);
                setIsMenuExtended(true);
            }
        }
    };

    useEffect(() => {
        if (location) {
            calculateIsActive(location);
        }
    }, [location, isExpandable, menuItem]);

    const checkHasVisibleChildren = (item: IMenuItem): boolean => {
        if (!item.children || item.children.length === 0) return false;
        // A child is considered "visible" if it is hienThi = true AND (it has a url OR it has visible children)
        // Wait, if it has a URL, it's a leaf. If it doesn't, it must have visible children.
        // The simplest check based on user request: "nếu chức năng cha có chức năng con mà chức năng con toàn bộ đều không hiển thị thì bỏ phần icon sổ xuống"
        return item.children.some(child => {
            if (!child.hienThi) return false;
            if (child.children && child.children.length > 0) {
                return checkHasVisibleChildren(child) || (child.url && child.url !== '#');
            }
            return true;
        });
    };

    useEffect(() => {
        if (!isMainActive && !isOneOfChildrenActive) {
            setIsMenuExtended(false);
        }
    }, [isMainActive, isOneOfChildrenActive]);

    useEffect(() => {
        const hasVisibleChildren = checkHasVisibleChildren(menuItem);
        setIsExpandable(hasVisibleChildren);
    }, [menuItem]);

    return (
        menuItem.hienThi ? <li className={`nav-item${isMenuExtended ? ' menu-open' : ''}`}>
            <a
                className={`nav-link${isMainActive || isOneOfChildrenActive ? ' active' : ''}`}
                role="link"
                onClick={handleMainMenuAction}
                style={{ cursor: 'pointer' }}
            >
                <i className={`${menuItem.icon}`} />
                {/*<p>{t<string>(menuItem.tenChucNang)}</p>*/}
                <p>{menuItem.tenChucNang}</p>
                {isExpandable ? <i className="right fas fa-angle-left" /> : null}
            </a>

            {isExpandable && menuItem && menuItem.children && (
                <ul className="nav nav-treeview">
                    {menuItem.children.map((item) => (
                        <MenuItem key={item.tenChucNang + (item.url || '')} menuItem={item} />
                    ))}
                </ul>
            )}
        </li> : null
    );
};

export default MenuItem;
